module.exports = __webpack_public_path__ + "28b67065/img/pdf-icon.79f04a36.svg";